<template>
  <div class="navigation-select" v-on:blur="open = false" tabindex="0">
    <div
      class="select-menu-button"
      :class="{ 'button-open': open }"
      color="#2D9CDB"
      @click="open = !open"
    >
      <div class="button-inner">
        <slot name="icon"></slot>
        <span class="menu-title">{{ menuButtonLabel }}</span>
        <feather-icon
          class="arrow-icon"
          :class="{ open: open }"
          icon="ChevronDownIcon"
          svgClasses="h-4 w-4"
        />
      </div>
    </div>
    <transition name="fade">
      <template>
        <div class="select-item-container vx-card" v-if="open">
          <div
            class="select-item"
            @click="onClickItem(option)"
            v-for="(option, index) in menuItemOptions"
            :key="index"
          >
            {{ option.name }}
          </div>
        </div>
      </template>
    </transition>
  </div>
</template>

<script>
/*
 * ナビゲーションセレクトコンポーネント
 * @props menuButtonLabel: String ドロップダウンボタンのラベル
 * @props menuItemOptions: Array 選択肢
 */

export default {
  props: {
    menuButtonLabel: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    menuItemOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    onClickItem(item) {
      this.$emit("onClickItem", item);
      this.open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.navigation-select {
  position: relative;
  min-width: 130px;
  max-width: 300px;
  margin-left: auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.select-menu-button {
  border-radius: 6px;
  border: none;
  background: $pm-blue;
  color: $pm-white;
  padding: 11.5px 15px !important;
  transition: all 300ms 0s ease;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    box-shadow: 0 9px 28px -9px $pm-blue;
  }
}
.button-open {
  border-radius: 4px 4px 0px 0px;
}
.menu-title {
  margin-right: 10px;
}
.vx-card {
  width: fit-content;
  overflow: hidden;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.select-item-container {
  position: absolute;
  z-index: 101;
  background: white;
  width: 100%;
}
.select-item {
  cursor: pointer;
  padding: 10.5px 15px;
}
.select-item:hover {
  background: $pm-transparent-blue;
  color: $pm-blue;
  transition: 0.2s;
}
.button-inner {
  display: flex;
  align-items: center;
}
.arrow-icon {
  margin-left: auto;
  transition: all 300ms 0s ease;
}
.open {
  transform: rotateZ(-180deg);
}
</style>
